<div class="card card-action" [class.closed]="!isExpanded" [draggable]="!isExpanded">
  <div class="card-menu-header" (click)="$event.preventDefault(); $event.stopPropagation(); isExpanded = !isExpanded">
    <div class="row">
      <div class="col-10">
        <div class="row" style="overflow: hidden; height: 40px;">
          <div class="col-1 d-none d-md-block"></div>
          <div class="col-2 d-none d-md-block">
            <div class="f-s-12 f-w-200">{{('Custom_Field_Setting.Shops' | trans)}}</div>
            <div class="f-s-13 f-w-700">
              @if (customFieldSetting.shopIds.length > 0) {
                {{ customFieldSetting.shopIds.length }}
              }
              @if (customFieldSetting.shopIds.length === 0) {
                {{('General.All' | trans)}}
              }
            </div>
          </div>
          <div class="col-2 d-none d-md-block">
            <div class="f-s-12 f-w-200">{{('Custom_Field_Setting.Events' | trans)}}</div>
            <div class="f-s-13 f-w-700">
              @if (customFieldSetting.eventIds.length > 0) {
                {{ customFieldSetting.eventIds.length }}
              }
              @if (customFieldSetting.eventIds.length === 0) {
                {{('General.All' | trans)}}
              }
            </div>
          </div>
          <div class="col-2 d-none d-md-block">
            <div class="f-s-12 f-w-200">{{('Custom_Field_Setting.Ticket_Types' | trans)}}</div>
            <div class="f-s-13 f-w-700">
              @if (customFieldSetting.ticketTypeIds.length > 0) {
                {{ customFieldSetting.ticketTypeIds.length }}
              }
              @if (customFieldSetting.ticketTypeIds.length === 0) {
                {{('General.All' | trans)}}
              }
            </div>
          </div>
          <div class="col-2 d-none d-md-block">
            <div
            class="f-s-12 f-w-200">{{('Custom_Field_Setting.Subscription_Types' | trans)}}</div>
            <div class="f-s-13 f-w-700">
              @if (customFieldSetting.subscriptionTypeIds.length > 0) {
                {{ customFieldSetting.subscriptionTypeIds.length }}
              }
              @if (customFieldSetting.subscriptionTypeIds.length === 0) {
                {{('General.All' | trans)}}
              }
            </div>
          </div>
        </div>
      </div>

      <div class="col-2 text-right">
        @if (isExpanded) {
          <button class="btn btn-secondary-icon">
            <span class="cm-icon cm-icon-delete" aria-hidden="true"
            (click)="$event.stopPropagation(); onDeleteCustomFieldSettingClicked()"></span>
          </button>
        }
      </div>
    </div>
  </div>
  <div class="card-menu">
    @for (menuItem of menuItems; track menuItem) {
      <div class="card-menu-item" (click)="onMenuItemClicked(menuItem)"
        [class.active]="activeMenuItem === menuItem.value">
        <div class="form-group">
          <div class="form-row">
            <div class="form-switch">
              <label class="switch">
                <input type="checkbox"
                  [checked]="isSettingEnabled(menuItem)"
                  (click)="$event.preventDefault()"
                  >
                <span class="slider round"></span>
              </label>
            </div>
            <span class="form-switch-label label" (click)="$event.preventDefault()">
              {{ menuItem.translationKey | trans }}
            </span>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="card-menu-content form-group">
    @if (activeMenuItem === 'SHOPS') {
      <div class="row">
        @for (shop of shops; track shop) {
          <div class="col-12 col-md-6">
            <div class="form-check m-b-8">
              <label>
                <input type="checkbox"
                  [checked]="isInSelection('shopIds', shop)"
                  (change)="onSelectionChanged('shopIds', shop)">
                <span class="label">{{shop.name}}</span>
              </label>
            </div>
          </div>
        }
      </div>
    }
    @if (activeMenuItem === 'EVENTS') {
      <div class="row">
        @for (event of events; track event) {
          <div class="col-12 col-md-6">
            <div class="form-check m-b-8">
              <label>
                <input type="checkbox"
                  [checked]="isInSelection('eventIds', event)"
                  (change)="onSelectionChanged('eventIds', event)">
                <span class="label">{{event.name}}</span>
              </label>
            </div>
          </div>
        }
      </div>
    }
    @if (activeMenuItem === 'TICKET_TYPES') {
      @if (!ticketTypes || customFieldSetting.subscriptionTypeIds.length > 0) {
        <div class="card-menu-content-disabled">
          <span class="cm-icon cm-icon-warning-open cl-error-color m-r-16" aria-hidden="true"></span>
          Only possible when only 1 event is selected, and no subscription types are selected.<br>
          Create multiple setting blocks if you want to filter ticket types.
        </div>
      }
      @if (ticketTypes && customFieldSetting.subscriptionTypeIds.length === 0) {
        <div class="row">
          @for (ticketType of ticketTypes; track ticketType) {
            <div class="col-12 col-md-6">
              <div class="form-check m-b-8">
                <label>
                  <input type="checkbox"
                    [checked]="isInSelection('ticketTypeIds', ticketType)"
                    (change)="onSelectionChanged('ticketTypeIds', ticketType)">
                  <span class="label">{{ticketType.name}}</span>
                </label>
              </div>
            </div>
          }
        </div>
      }
    }
    @if (activeMenuItem === 'SUBSCRIPTION_TYPES') {
      @if (customFieldSetting.ticketTypeIds.length > 0) {
        <div class="card-menu-content-disabled">
          <span class="cm-icon cm-icon-warning-open cl-error-color m-r-16" aria-hidden="true"></span>
          Subscription types cannot be combined with ticket types.<br>
          Create multiple setting blocks if you want to add subscription types.
        </div>
      }
      @if (customFieldSetting.ticketTypeIds.length === 0) {
        <div class="row">
          @for (subscriptionType of subscriptionTypes; track subscriptionType) {
            <div class="col-12 col-md-6">
              <div class="form-check m-b-8">
                <label>
                  <input type="checkbox"
                    [checked]="isInSelection('subscriptionTypeIds', subscriptionType)"
                    (change)="onSelectionChanged('subscriptionTypeIds', subscriptionType)">
                  <span class="label">{{subscriptionType.name}}</span>
                </label>
              </div>
            </div>
          }
        </div>
      }
    }
  </div>
</div>

